/**
 * Opens the legal guarantee page in a dialog instead of navigating away.
 */
(function () {
  function keepSingleDialog() {
    const dialogs = document.querySelectorAll('dialog.legal-guarantee-modal');
    let keeper = null;

    for (const dialog of dialogs) {
      if (!keeper) {
        keeper = dialog;
        continue;
      }
      dialog.remove();
    }

    if (keeper && keeper.parentElement !== document.body) {
      document.body.appendChild(keeper);
    }

    return keeper;
  }

  function bindDialog(dialog) {
    if (!dialog || dialog.dataset.bound === 'true') return;

    dialog.dataset.bound = 'true';
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });
    dialog.addEventListener('close', () => {
      document.body.classList.remove('legal-guarantee-open');
    });
  }

  function openDialog(dialog) {
    if (!dialog || typeof dialog.showModal !== 'function' || dialog.open) return;

    if (dialog.parentElement !== document.body) {
      document.body.appendChild(dialog);
    }

    document.body.classList.add('legal-guarantee-open');
    dialog.showModal();
  }

  function init() {
    bindDialog(keepSingleDialog());
  }

  if (!window.legalGuaranteeModalBound) {
    window.legalGuaranteeModalBound = true;

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;

      const dialog = document.querySelector('dialog.legal-guarantee-modal');
      if (!dialog?.open) return;

      dialog.close();
    });

    document.addEventListener('click', (event) => {
      const closeButton = event.target.closest('[data-legal-guarantee-close]');
      if (closeButton) {
        closeButton.closest('dialog')?.close();
        return;
      }

      const trigger = event.target.closest('[data-legal-guarantee-open]');
      if (!trigger) return;

      const dialog = document.querySelector('dialog.legal-guarantee-modal');
      if (!dialog || typeof dialog.showModal !== 'function') return;

      event.preventDefault();
      bindDialog(dialog);
      openDialog(dialog);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
